<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Seleccione sus opciones</v-toolbar-title
              >
            </v-toolbar>
            <v-card-actions class="pb-3">
              <!-- <v-flex xs4 order-md1> -->
              <!-- v-if="usuarioLoggedTipe=='PROVEEDOR' || usuarioLoggedTipe=='ADMINISTRADOR'"  -->
              <!-- <v-btn          
                  color="primary" 
                  @click="descargaPlantilla()"
                  >Descarga Plantilla Acuerdo</v-btn>
                </v-flex> -->
              <!-- v-if="usuarioLoggedTipe=='PROVEEDOR' || usuarioLoggedTipe=='ADMINISTRADOR'"  -->
              <!-- <v-flex xs5 order-md3  grid-list-xl>
                  <v-toolbar-title                
                  class="indigo--text"
                  >Carga masiva acuerdo</v-toolbar-title>
                  <data-adjunto
                  :documentoId="id" 
                  :tipeView="tipeView" 
                  :tipeArchive="tipeArchive">
                  </data-adjunto>         
                </v-flex> -->
              <!-- v-if="tabSelected=='Operacion' && (usuarioLoggedTipe=='PROVEEDOR' || usuarioLoggedTipe=='ADMINISTRADOR')" -->
              <!-- <v-flex xs3 order-md4>
                 <v-btn                 
                      depressed 
                      outline 
                      icon 
                      fab 
                      dark 
                      color="primary"
                      medium 
                      title="Cargar planilla" 
                      @click="cargaMasiva()">
                      cargar
                  </v-btn>
                </v-flex> -->
            </v-card-actions>
            <botones-acuerdo-distribucion
              :key="botonesUsuario"
            ></botones-acuerdo-distribucion>
            <grid-ultimo-acuerdo-distribucion
              :key="ultimoAcuerdo"
            ></grid-ultimo-acuerdo-distribucion>
            <!-- TABLA DOCUMENTO -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <grid-documento-diario-acuerdo
                :key="gridDocumento"
                :rowsTable="rowsTable"
              ></grid-documento-diario-acuerdo>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import BotonesAcuerdoDistribucion from "@/modules/distribucion/views/acuerdo/BotonesAcuerdoDistribucion.vue";
import GridUltimoAcuerdoDistribucion from "@/modules/distribucion/views/acuerdo/GridUltimoAcuerdoDistribucion.vue";
import GridDocumentoDiarioAcuerdo from "@/modules/distribucion/views/acuerdo/GridDocumentoDiarioAcuerdo.vue";
import VisitaSubTab from "@/modules/visitas/views/VisitaSubTab.vue";
import Loading from "@/views/ui/Loading.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";

export default {
  name: "menu-sub-proceso-distribucion",

  components: {
    GridDocumentoDiarioAcuerdo,
    BotonesAcuerdoDistribucion,
    GridUltimoAcuerdoDistribucion,
    Loading,
    DataAdjunto,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      tabs: ["Acuerdo", "Progreso", "Contingencia", "Calidad"],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      botonesUsuario: 0,
      ultimoAcuerdo: 10,
      gridDocumento: 20,
      idEstado: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {},

  methods: {
    reloadAcuerdo() {
      this.ultimoAcuerdo += 11;
    },
    reloadBoton() {
      this.botonesUsuario += 1;
    },
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
    filterDoc() {
      this.filter = true;
    },
  },
};
</script>
